var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height scrollable"},[(_vm.startingUp)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_c('client-list',{staticClass:"flex-grow-1 scrollable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }